/**
 * Focuses a new reminder chip and positions the cursor appropriately
 */
export function focusNewReminderChip(chipIndex: number, delay: number = 50): void {
  setTimeout(() => {
    // Query for the new chip using the data-attribute and its predicted visual index.
    const newReminderEl = document.querySelector(`[data-reminder-idx="${chipIndex}"]`);

    if (newReminderEl instanceof HTMLElement) {
      newReminderEl.focus(); // Focus the contentEditable span.

      const selection = window.getSelection();
      const range = document.createRange();

      // A new chip's span will be empty as ReminderChip renders "" for 0/null.
      // Check if the span is truly empty or if it somehow contains a text node.
      if (newReminderEl.firstChild && newReminderEl.firstChild.nodeType === Node.TEXT_NODE && newReminderEl.firstChild.textContent !== "") {
        // If there's non-empty text content, place cursor at the end of it.
        range.selectNodeContents(newReminderEl);
        range.collapse(false); // Collapse selection to the end.
      } else {
        // If the span is empty or contains an empty text node, place cursor at the start.
        range.setStart(newReminderEl, 0);
        range.collapse(true); // Collapse selection to a caret at the start.
      }

      if (selection) { // Ensure selection API is available.
        selection.removeAllRanges(); // Clear any existing selection.
        selection.addRange(range); // Apply the new selection (caret position).
      }
    }
  }, delay);
}
